<template>
  <div v-if="issueData"
       class="report-code"
       @click="clearHighlight">
    <ul class="tree-menu">
      <report-code-item
        :isClearHighlight="isClearHighlight"
        :nodeId="rootNodeId"
        :nodeDataMap="nodeDataMap"
        :currentIssue="currentIssue" />
    </ul>
  </div>
</template>

<script>
import ReportCodeItem from './ReportCodeItem'

export default {
  name: 'DiagnosisReportCode',
  props: ['nodeDataMap', 'currentIssue', 'scrollTop', 'issueData'],
  components: {
    ReportCodeItem
  },
  data () {
    return {
      isClearHighlight: false
    }
  },
  computed: {
    rootNodeId () {
      return this.nodeDataMap[1].id
    }
  },
  watch: {
    currentIssue (value) {
      this.isClearHighlight = false
    },
    scrollTop (value) {
      if (this.$el) {
        this.$el.scrollTop = value - 40
        this.$el.scrollLeft = 0
      }
    }
  },
  methods: {
    clearHighlight () {
      this.isClearHighlight = true
    }
  }
}
</script>

<style lang="scss">
.report-code {
  text-align: left;
  position: relative;
  overflow: auto;
  font-size: 13px;
  padding: 20px 15px;
  flex-basis: 736px;
  flex-grow: 2;
  border-radius: 0 0 10px 10px;
  background: #222222;
  color: #c1c1c1;
  outline: 1px solid rgba(255, 255, 255, 0.3);;

  * {
    font-family: monospace !important;
  }

  .tree-menu {
    margin-left: 8px;

    span {
      font-weight: normal;
    }

    .active-node {
      background-color: #f4f4f4;

      & > div strong,
      .tree-menu .active-node > div strong span{
        color: #000000;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/valid-member/report/ReportCode.vue